export default "__VITE_ASSET__DZdqDjgi__"